import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import { useReset } from "../../modules/user/hooks/use-reset";

export default function ResetPage() {

    const reset = useReset();

    useEffect(() => {
        reset();
    }, [reset])

    return (<>
        <Link to={'/'}>Wróć do gry</Link>
    </>)
}
